import { useGetMeQuery } from "graphqlBase/currentUser/__generated__/getMe";

export const useGetCurrentUser = () => {
  const { data, loading, error } = useGetMeQuery();

  const getInitials = (name?: string): string => {
    if (!name) return "";
    return name
      .split(/\s+/)
      .map((part) => part.replace(/[^\p{L}\p{N}]/gu, "")) // strip non letters/digits, e.g. "(mlpa)" -> "mlpa"
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

  const user = data?.me;
  const initials = getInitials(user?.displayName);

  return {
    user,
    initials,
    loading,
    error,
    roles: user?.permissions?.roles ?? [],
    tenantName: user?.tenants.find((tenant) => tenant.isCurrentTenant)?.tenantName,
  };
};
